<!--
  @component Navbar.Skip

  A skip-to-content link component for improved accessibility in the navbar.
  This component provides a way for keyboard users to bypass repetitive navigation
  and jump directly to the main content of the page.

  @prop href - The URL or anchor the skip link points to (required)
  @prop label - The text displayed for the skip link (required)
  @prop css - Custom CSS styles to apply to the skip link

  Example:
  <Navbar.Skip href="#main-content" label="Skip to main content" />
-->

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { navbarSkipStyles } from '../navbar.styles';
  import type { NavbarSkipProps } from '../navbar.types';

  /** Props for the Navbar.Skip component */
  const { href, label, css: cssProp }: NavbarSkipProps = $props();
</script>

<a href={href} tabindex="0" class={css(navbarSkipStyles, cssProp)}>
  {label}
</a>
